var render = function render(_c,_vm){return _c('VueSelect',_vm._g(_vm._b({staticClass:"custom-select",class:[_vm.data.class, _vm.data.staticClass]},'VueSelect',_vm.data.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }